<div class="body" [formGroup]="formGroup">
    
    <div class="row">

        <mat-form-field [appearance]="appearance">
            <mat-label class="label">Produktnummer</mat-label>
            <input formControlName="productnumber" matInput placeholder="z.B. 1.1.2.2" [readonly]="!editMode" />
        </mat-form-field>

        <mat-form-field class="width" [appearance]="appearance">
            <mat-label class="label">Service, Produktbezeichnung</mat-label>
            <input formControlName="productservice" matInput placeholder="z.B. Analoger Anschluss" [readonly]="!editMode" />
        </mat-form-field>

    </div>

    <mat-form-field class="width" [appearance]="appearance">
        <mat-label class="label">Beschreibung</mat-label>
        <textarea formControlName="productdesc" matInput rows="6"></textarea>
    </mat-form-field>

    <app-select-product-type [appearance]="appearance" formControlName="producttype"></app-select-product-type>

    <div class="row">

        <mat-form-field [appearance]="appearance" (click)="ref1.focus()" (focus)="ref1.focus()" tabindex="0">

            <input formControlName="productsetupcost" class="input" matInput placeholder="z.B. 10,50" [readonly]="!editMode" #ref1=hiddenInput appHiddenInput />
            <label *ngIf="!ref1.focussed">
                Einrichtung: {{productsetupcostControl.value? (productsetupcostControl.value|currency:'EUR':'symbol'): '-'}}
            </label>

        </mat-form-field>

        <mat-form-field [appearance]="appearance" (click)="ref2.focus()" (focus)="ref2.focus()" tabindex="0">

            <input formControlName="productrentalcost" class="input" matInput placeholder="z.B. 10,50" [readonly]="!editMode" #ref2=hiddenInput appHiddenInput />
            <label *ngIf="!ref2.focussed">
                Miete: {{productrentalcostControl.value? (productrentalcostControl.value|currency:'EUR':'symbol'): '-'}}
            </label>

        </mat-form-field>

        <mat-form-field [appearance]="appearance" (click)="ref3.focus()" (focus)="ref3.focus()" tabindex="0">

            <input formControlName="productpurchasecost" class="input" matInput placeholder="z.B. 10,50" [readonly]="!editMode" #ref3=hiddenInput appHiddenInput />
            <label *ngIf="!ref3.focussed">
                Kauf: {{productpurchasecostControl.value? (productpurchasecostControl.value|currency:'EUR':'symbol'): '-'}}
            </label>

        </mat-form-field>

    </div>

</div>
